import React from 'react';
import { useParams } from 'react-router-dom';

import OpportunityDetailsLayout from '@totem/components/services/optimize/opportunityDetails/OpportunityDetailsLayout';
import TicketingConfigurationContainer from '@totem/components/ticketing/configuration/ticketingConfigurationContainer';
import TicketContainer from '@totem/components/ticketing/details/ticketContainer';

const OpportunityDetailsPage = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <TicketContainer ticketId={id}>
      <TicketingConfigurationContainer>
        <OpportunityDetailsLayout />
      </TicketingConfigurationContainer>
    </TicketContainer>
  );
};

export default OpportunityDetailsPage;
